/* 360 Water Filtration — site-wide UX enhancements */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Resolve an in-page anchor target. Handles the case where hero/CTA links use a
  // short section id (e.g. "shopify-section-ro_featured") while Online Store 2.0
  // actually renders "shopify-section-template--<n>__ro_featured".
  function findTarget(id) {
    var el = document.getElementById(id);
    if (el) return el;
    var suffix = id.replace(/^shopify-section-/, '');
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].id.split('__').pop() === suffix) return sections[i];
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;
    var target = findTarget(hash.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', hash);
  }, false);
})();
